import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ROUTES, isAustral } from "../utils/constants";
import { useTranslation } from "react-i18next";
import Austral from "../pages/Austral";
import Etech from "../pages/Etech";
import RenaultDuster from "../pages/RenaultDuster";
import RenaultKangooMultix from "../pages/RenaultKangooMultix";
import RenaultMaster from "../pages/RenaultMaster";
import Clio6 from "../pages/Clio6";

const AppRouter = () => {
  const { t } = useTranslation();

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path={ROUTES.AUSTRAL} element={<Austral />} />
        <Route exact path={ROUTES.ETECH} element={<Etech />} />
        <Route exact path={ROUTES.RENAULT_DUSTER} element={<RenaultDuster />} />
        <Route exact path={ROUTES.RENAULT_KANGOO_MULTIX} element={<RenaultKangooMultix />} />
        <Route exact path={ROUTES.RENAULT_MASTER} element={<RenaultMaster />} />
        <Route exact path={ROUTES.CLIO6} element={<Clio6 />} />

        <Route path="*" element={<Navigate to="/renault_master" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
export default AppRouter;
